import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Clipboard } from "@angular/cdk/clipboard";
import { TdspPixelService } from "src/app/core/services/tdsp/tdsp-pixel.service";
import { TdspConversionPixelService } from "src/app/core/services/tdsp/tdsp-conversion-pixel.service";

@Component({
  selector: "app-tdsp-get-pixel-tag",
  templateUrl: "./tdsp-get-pixel-tag.component.html",
  styleUrl: "./tdsp-get-pixel-tag.component.scss",
})
export class TdspGetPixelTagComponent implements OnInit {
  globalParams: Object = {};
  pixelId: number;
  tagCode: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    private clipboard: Clipboard,
    private pixelService: TdspPixelService,
    private conversionPixelService: TdspConversionPixelService
  ) {}

  ngOnInit(): void {
    this.globalParams = this.data.globalParams;
     if (this.data.isBulk) {
    this.getBulkTags();
  } else {
    this.pixelId = this.data.pixelId;
    this.getTag();
  };
  }

  getTag() {
    let service =
      this.data.type == "universal-pixel"
        ? this.pixelService
        : this.conversionPixelService;
          const params = {
    ...this.globalParams,
    pixel_ids: this.pixelId,
  };
    service.getPixelTag(params).subscribe((res) => {
      this.tagCode =
        this.data.type == "universal-pixel" ? res.tags : res.data.image_tags?.[0];
    });
  }
  
    getBulkTags() {
      const params = {
        ...this.globalParams,
        pixel_ids: this.data.pixelIds.join(',')
      };

      const service =
        this.data.type === 'universal-pixel'
          ? this.pixelService
          : this.conversionPixelService;

      service.getBulkPixelTags(params).subscribe(res => {
        if (this.data.type === 'universal-pixel') {
          this.tagCode = res.tags?.join('\n\n') || '';
        } else {
          this.tagCode = res.data?.image_tags?.join('\n\n') || '';
        }
      });
    }
  copyToClipboard() {
    this.clipboard.copy(this.tagCode);
  }

  closePopUp() {
    this.dialogRef.close();
  }
}
